import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../types/store';
import { getBatchAction } from '../../selectors/studio';
import { Props } from './BatchEditOrDeleteConfirmation';

export type StateProps = Pick<Props, 'batchAction'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  batchAction: getBatchAction(state)!,
});

export default connect(mapStateToProps);
